import * as Immutable from "immutable";
import FileTrait from "./trait.file.jsx";

const UploadedFileRecord = Immutable.Record(
  {
    code: ``,
    class: ``,
    sizeValue: 0,
    name: ``,
    mime_type: ``,
    uploading: false,
    progress: 0,
    thumbnail_url: ``,
    error: ``,
  },
  `UploadedFile`
);

class UploadedFile extends UploadedFileRecord {
  constructor(data) {
    super(data);
    this.isDropboxFile = FileTrait.isDropboxFile.bind(this);
    this.isGoogleDriveFile = FileTrait.isGoogleDriveFile.bind(this);
    this.isLocalFile = FileTrait.isLocalFile.bind(this);
    this.isWarehouseFile = FileTrait.isWarehouseFile.bind(this);
    this.getThumbnailUrl = FileTrait.getThumbnailUrl.bind(this);
    this.getSize = FileTrait.getSize.bind(this);
  }
}

export default UploadedFile;
